import { Component } from 'react'
import { Code, CodeableConcept, CodeableConcepts, UDICarriers, DeviceName } from '../helpers'
import { GiHeartBattery } from 'react-icons/gi'
import moment from 'moment'
import './resource.css'

class Device extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GiHeartBattery /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.statusReason && 'Reason'}</div>
                            <div className='Res-Title'>{this.props.resource.statusReason && CodeableConcepts(this.props.resource.statusReason)}</div>
                        </div>
                    </div>
                    {this.props.resource.udiCarrier && <div className='Res-row'>
                        {UDICarriers(this.props.resource.udiCarrier)}
                    </div>}
                    {this.props.resource.distinctIdentifier && <div>
                        <div className='Res-Detail Res-Content-Rev'>ID</div>
                        <div className='Res-Title'>{this.props.resource.distinctIdentifier}</div>
                    </div>}
                    {this.props.resource.manufacturer && <div>
                        <div className='Res-Detail Res-Content-Rev'>Manufacturer</div>
                        <div className='Res-Title'>{this.props.resource.manufacturer}</div>
                    </div>}
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.manufactureDate && 'Manufactured'}</div>
                            <div className='Res-Title'>{this.props.resource.manufactureDate && moment(this.props.resource.manufactureDate).format('lll')}</div>
                        </div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.expirationDate && 'Expires'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.expirationDate && moment(this.props.resource.expirationDate).format('lll')}</div>
                        </div>
                    </div>
                    {this.props.resource.deviceName && <div className='Res-row'>
                        {DeviceName(this.props.resource.deviceName)}
                    </div>}
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.modelNumber && 'Model'}</div>
                            <div className='Res-Title'>{this.props.resource.modelNumber || ''}</div>
                        </div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.partNumber && 'Part'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.partNumber || ''}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.lotNumber && 'Lot'}</div>
                            <div className='Res-Title'>{this.props.resource.lotNumber || ''}</div>
                        </div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.serialNumber && 'Serial Number'}</div>
                            <div style={{ textAlign: 'right' }} className='Res-Title'>{this.props.resource.serialNumber || ''}</div>
                        </div>
                    </div>
                    {this.props.resource.type && <div>
                        <div className='Res-Detail Res-Content-Rev'>Type</div>
                        <div className='Res-Title'>{CodeableConcept(this.props.resource.type)}</div>
                    </div>}
                </div>
            }
        </div></div>
    }
}

export default Device